const rawPhoneLength = import.meta.env.VITE_PHONE_LENGTH
export const PHONE_LENGTH = rawPhoneLength ? Number(rawPhoneLength) : 10
export const PHONE_COUNTRY_CODE =
  import.meta.env.VITE_PHONE_COUNTRY_CODE ?? '+52'

// Maximum password length enforced across registration, login, and the
// password reset/change flows (native `maxLength` on the inputs).
export const MAX_PASSWORD_LENGTH = 50
